export enum SpotType {
  podcast = 'Podcast',
  legacy = 'Legacy',
}
